import { categories } from "@/mocks/banana";

export default function Categories() {
  return (
    <section id="categories" className="bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-800">
              <i className="ri-grid-fill" />
              漫画分类
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">
              海量题材，总有一款适合你
            </h2>
          </div>
          <p className="max-w-md text-sm text-foreground-600 md:text-right">
            热血、恋爱、悬疑、玄幻、搞笑……全题材覆盖，满足每一位读者的口味。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-4 md:grid-cols-4">
          {categories.map((c) => (
            <a
              key={c.name}
              href="#popular"
              className="group relative overflow-hidden rounded-2xl"
            >
              <img
                src={c.image}
                alt={`${c.name}漫画分类，${c.desc}`}
                title={`香蕉漫画 ${c.name} 分类`}
                className="h-52 w-full object-cover transition-transform duration-500 group-hover:scale-110 md:h-64"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4">
                <h3 className="font-heading text-lg text-white">{c.name}</h3>
                <p className="mt-1 line-clamp-2 text-xs text-white/80">
                  {c.desc}
                </p>
                <span className="mt-2 inline-flex items-center gap-1 rounded-full bg-white/20 px-2.5 py-1 text-xs text-white backdrop-blur-sm">
                  {c.count}部作品
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}